import { request } from '@alife/cn-request';
import habit from './habit';
import feedback from './feedback';
export const formatSuggestionsApiResponse = (res) => {
    const suggestList = [];
    if (res?.success && Array.isArray(res.data)) {
        res.data.forEach((item) => {
            const { history = false, sugContentList = [], name = '', tagEnabled = false, entityType = '', entityKey = '', sugType = 'default', analyzeType, } = item;
            if (history) {
                sugContentList.forEach((sugContent = '') => {
                    if (sugContent) {
                        if (typeof sugContent === 'string' && sugContent.trim()) {
                            const tmpSug = {
                                history,
                                value: sugContent.trim(),
                                tagEnabled,
                                entityType,
                                entityKey,
                            };
                            if (analyzeType) {
                                tmpSug.analyzeType = analyzeType;
                            }
                            suggestList.push(tmpSug);
                        }
                        else if (typeof sugContent === 'object') {
                            const tmpSug = {
                                ...sugContent,
                                history,
                                tagEnabled,
                                entityType,
                                entityKey,
                            };
                            if (analyzeType) {
                                tmpSug.analyzeType = analyzeType;
                            }
                            suggestList.push(tmpSug);
                        }
                    }
                });
            }
            else {
                const suggestItem = {
                    history,
                    tagEnabled,
                    entityType,
                    entityKey,
                    sugType,
                };
                if (entityKey && name) {
                    const tmpSug = {
                        ...suggestItem,
                        name,
                        value: null,
                    };
                    if (analyzeType) {
                        tmpSug.analyzeType = analyzeType;
                    }
                    suggestList.push(tmpSug);
                }
                if (sugContentList.length > 0) {
                    sugContentList.forEach((sugContent = '') => {
                        if (sugContent) {
                            if (typeof sugContent === 'string' && sugContent.trim()) {
                                const tmpSug = {
                                    ...suggestItem,
                                    name,
                                    value: sugContent.trim(),
                                };
                                if (analyzeType) {
                                    tmpSug.analyzeType = analyzeType;
                                }
                                suggestList.push(tmpSug);
                            }
                            else if (typeof sugContent === 'object') {
                                const tmpSug = {
                                    ...suggestItem,
                                    name,
                                    ...sugContent,
                                };
                                if (analyzeType) {
                                    tmpSug.analyzeType = analyzeType;
                                }
                                suggestList.push(tmpSug);
                            }
                        }
                    });
                }
                else if (!entityKey) {
                    if (sugType !== 'custom') {
                        const tmpSug = {
                            ...suggestItem,
                            value: name,
                        };
                        if (analyzeType) {
                            tmpSug.analyzeType = analyzeType;
                        }
                        suggestList.push(tmpSug);
                    }
                    else {
                        const tmpSug = {
                            ...suggestItem,
                            value: '',
                            name,
                        };
                        if (analyzeType) {
                            tmpSug.analyzeType = analyzeType;
                        }
                        suggestList.push(tmpSug);
                    }
                }
            }
        });
    }
    return suggestList;
};
export const fetchSuggestions = async (api, keyword, bizAccessKey) => {
    const res = await request({
        url: api,
        method: 'POST',
        data: {
            keyword,
            bizAccessKey,
        },
    });
    return formatSuggestionsApiResponse(res);
};
// 默认的fetchSuggestions，用于兼容旧的suggest接口
export const defaultFetchSuggestions = async (api, keyWord, bizAccessKey, operatorId, bizContext, isEnhancedAnalisys) => {
    const baseInfoContext = {
        bizAccessKey,
        operatorId,
        operator: operatorId,
    };
    if (bizContext) {
        baseInfoContext.context = bizContext;
    }
    const res = await request({
        url: api,
        method: 'POST',
        data: {
            param: {
                baseInfoContext,
                keyWord,
                content: keyWord,
            },
        },
    });
    return formatSuggestionsApiResponse({
        data: res.data?.data?.sugGroupList || res?.data?.sugGroupList || [],
        success: res.data?.data?.success || res.data?.success,
        isEnhancedAnalisys,
    });
};
// 组件默认的字段转换函数，用于兼容旧的suggest接口
export const defaultFetchTransformFields = async (api, bizAccessKey, operatorId, searchTokenList, bizContext) => {
    const baseInfoContext = {
        bizAccessKey,
        operatorId,
        operator: operatorId,
    };
    if (bizContext) {
        baseInfoContext.context = bizContext;
    }
    const res = await request({
        url: api,
        method: 'POST',
        data: {
            param: {
                baseInfoContext,
                searchTokenList,
            },
        },
    });
    return res?.data?.data || res?.data;
};
export const formatDefaultTransformFieldsApiResponse = (entityInfos) => {
    const result = {};
    entityInfos?.forEach((item) => {
        result[item.entityKey] = item;
    });
    return result;
};
/**
 * 默认的transformSearchParams函数，用于前端调用算法接口结果转换
 * @param tokenTranslatorResult
 * @returns
 */
export const formatDefaultTransformSearchParams = (tokenTranslatorResult) => {
    const result = {};
    const { entityInfos = [] } = tokenTranslatorResult || {};
    const opKindMap = {};
    entityInfos?.forEach((item) => {
        result[item.entityKey] =
            typeof item.entityValues !== 'undefined' ? item.entityValues : '';
        opKindMap[item.entityKey] =
            typeof item.opKind !== 'undefined' ? item.opKind : '';
    });
    if (Object.keys(opKindMap).length > 0) {
        result._cnOneSearchResultOpKindMap = opKindMap;
    }
    if (tokenTranslatorResult.searchView) {
        result.searchView = tokenTranslatorResult.searchView;
    }
    return result;
};
export const genViewSelectorDataSource = (views = [], defaultHabits = [], $i18n) => {
    const emptyView = {
        id: '',
        name: '',
        filter: {
            searchTags: [],
        },
    };
    const genNewFilter = (filter = {}) => {
        const newFilter = {
            searchTags: [],
            ...filter,
        };
        newFilter.searchTags = newFilter.searchTags || [];
        newFilter.searchTags = newFilter.searchTags.map((tag = { values: [] }) => {
            return {
                ...tag,
                isFromView: true,
            };
        });
        return newFilter;
    };
    const dataSource = [];
    if (Array.isArray(defaultHabits) && defaultHabits.length > 0) {
        dataSource.push({
            label: $i18n.get({ id: 'PresetQueryConditions', dm: '预置查询条件' }),
            type: 'system',
            children: defaultHabits.map((v = emptyView) => {
                return {
                    ...v,
                    label: v.name,
                    value: v.id,
                    type: 'system',
                    filter: genNewFilter(v.filter),
                };
            }),
        });
    }
    if (Array.isArray(views) && views.length > 0) {
        dataSource.push({
            label: $i18n.get({ id: 'MyQueryCriteria', dm: '我的查询条件' }),
            type: 'custom',
            children: views.map((v = emptyView) => {
                return {
                    ...v,
                    label: v.name,
                    value: v.id,
                    type: 'custom',
                    filter: genNewFilter(v.filter),
                };
            }),
        });
    }
    return dataSource;
};
export const getViewDetailFromDataSource = (dataSource = [], viewId) => {
    const views = [];
    dataSource.forEach((v) => {
        if (v.children) {
            views.push(...v.children);
        }
    });
    const view = views.find((v) => v.value === viewId);
    return view;
};
export const isFilterValueEmpty = (filterValue) => {
    if (typeof filterValue === 'string') {
        return !filterValue || filterValue.indexOf('suggest-fake-value-') > -1;
    }
    if (Array.isArray(filterValue)) {
        return filterValue.length === 0;
    }
    if (typeof filterValue === 'object' && filterValue !== null) {
        return Object.keys(filterValue).length === 0;
    }
    return typeof filterValue === 'undefined' || filterValue === null;
};
export const isViewModified = (viewDetail, searchQuery = {}, searchTags = []) => {
    const { filter } = viewDetail || {};
    const { searchQuery: viewSearchQuery = {}, searchTags: viewSearchTags = [] } = filter || {};
    return (JSON.stringify(searchQuery) !== JSON.stringify(viewSearchQuery) ||
        JSON.stringify(searchTags) !== JSON.stringify(viewSearchTags));
};
/**
 * 计算新的搜索标签组
 * @param {Array} curTags 当前的搜索标签组
 * @param {Object} newSearchItem 新的搜索项
 * @return {Array}
 */
export const genSearchTags = (curTags = [], newSearchItem = {}) => {
    const { suggestItem, keyword = '' } = newSearchItem;
    const { name = '', entityType = '', entityKey = '', entityValue, tagEnabled, analyzeType = '', isRepeatCover = false, isStrictCompare = false, } = suggestItem || {};
    let { value } = suggestItem || {};
    if (typeof value === 'string' && value.indexOf('suggest-fake-value-') > -1) {
        value = undefined;
    }
    let newValues = [];
    let newLabels = [];
    if (name && tagEnabled) {
        let matchSameNameTag = null;
        if (isStrictCompare) {
            matchSameNameTag = curTags.find((v) => {
                if (entityKey || v.entityKey) {
                    return v.entityKey === entityKey && v.analyzeType === analyzeType;
                }
                return v.name === name && v.analyzeType === analyzeType;
            });
        }
        else {
            matchSameNameTag = curTags.find((v) => {
                if (entityKey || v.entityKey) {
                    return v.entityKey === entityKey;
                }
                return v.name === name;
            });
        }
        if (matchSameNameTag) {
            const { values = [], labels = [] } = matchSameNameTag;
            // 已经有相同的属性值，不重复添加
            if (!entityKey && values.includes(value)) {
                return curTags;
            }
            else if (entityKey && labels.includes(value)) {
                return curTags;
            }
            else if (isFilterValueEmpty(value) && !isRepeatCover) {
                return curTags;
            }
            return curTags.map((v) => {
                if (v.name === name && !entityKey) {
                    return {
                        ...v,
                        values: [...(v.values || []), value],
                    };
                }
                else if (v.entityKey === entityKey && !isRepeatCover) {
                    return {
                        ...v,
                        labels: [...(v.labels || []), value],
                        values: isFilterValueEmpty(entityValue)
                            ? v.values
                            : [...(v.values || []), entityValue],
                    };
                }
                else if (v.entityKey === entityKey &&
                    v.analyzeType === analyzeType &&
                    isRepeatCover) {
                    return {
                        ...v,
                        entityType,
                        labels: Array.isArray(value) ? value : [value],
                        values: Array.isArray(entityValue) ? entityValue : [entityValue],
                    };
                }
                return v;
            });
        }
        if (!isFilterValueEmpty(value)) {
            if (entityKey) {
                if (!isRepeatCover) {
                    newLabels = [value];
                    if (!isFilterValueEmpty(entityValue)) {
                        newValues = [entityValue];
                    }
                }
                else {
                    newLabels = Array.isArray(value) ? value : [value];
                    if (!isFilterValueEmpty(entityValue)) {
                        newValues = Array.isArray(entityValue)
                            ? entityValue
                            : [entityValue];
                    }
                }
            }
            else {
                newValues = [value];
            }
        }
    }
    else {
        if ((typeof keyword === 'string' && !keyword.trim()) ||
            typeof keyword === 'undefined' ||
            keyword === null) {
            return curTags;
        }
        // 已有相同的keyword，不重复添加
        const hasSameKeyword = curTags.some((v) => Array.isArray(v.values) && !v.name && v.values.includes(keyword));
        if (hasSameKeyword) {
            return curTags;
        }
        newValues = [keyword];
    }
    return curTags.concat({
        name,
        entityType,
        entityKey,
        values: newValues,
        labels: newLabels,
        analyzeType,
    });
};
export const deleteSearchTags = (curTags = [], newSearchItem = {}) => {
    const { suggestItem, keyword = '' } = newSearchItem;
    const newCurTags = []; // 过滤掉删除目标后的内容
    if (keyword) {
        curTags.forEach((item) => {
            // 删除和当前tags中有重复的自然语言tag
            if (item.values.indexOf(keyword) < 0) {
                newCurTags.push(item);
            }
        });
    }
    if (suggestItem) {
        const { analyzeType, entityKey, isStrictCompare = false } = suggestItem;
        if (isStrictCompare) {
            curTags.forEach((item) => {
                // 删除和当前tags中有重复entityKey和analyzeType的结构化tag
                if (!(item.entityKey === entityKey && item.analyzeType === analyzeType)) {
                    newCurTags.push(item);
                }
            });
        }
        else {
            curTags.forEach((item) => {
                // 删除和当前tags中有重复entityKey的结构化tag
                if (item.entityKey !== entityKey) {
                    newCurTags.push(item);
                }
            });
        }
    }
    return newCurTags;
};
export const reorderSearchTags = (curTags = [], params = {}) => {
    const { dragTag, dragTagKeyword, dropTag, dropTagKeyword } = params;
    let oldIndex = 0;
    if (dragTagKeyword) {
        oldIndex = curTags.findIndex((item) => item.values.indexOf(dragTag) >= 0);
    }
    if (dragTag) {
        const { entityKey, analyzeType } = dragTag;
        oldIndex = curTags.findIndex((item) => item.entityKey === entityKey && item.analyzeType === analyzeType);
    }
    const oldTag = curTags.find((_, index) => index === oldIndex) ?? {
        values: [],
    };
    let newIndex = 0;
    if (dropTagKeyword) {
        newIndex = curTags.findIndex((item) => item.values.indexOf(dropTag) >= 0);
    }
    if (dropTag) {
        const { entityKey, analyzeType } = dropTag;
        newIndex = curTags.findIndex((item) => item.entityKey === entityKey && item.analyzeType === analyzeType);
    }
    if (oldIndex === newIndex) {
        return curTags;
    }
    let newOrderSearchTags = [];
    newOrderSearchTags = [...curTags];
    // 删除之前DOM节点
    newOrderSearchTags.splice(oldIndex, 1);
    // 在拖拽结束目标位置增加新的DOM节点
    newOrderSearchTags.splice(newIndex, 0, oldTag);
    return newOrderSearchTags;
};
export const reportHottag = (logItem = { sampling: 1 }) => {
    if (window.coneArmsTrace && window.coneArmsTrace.reportHottag) {
        logItem.sampling = 1;
        window.coneArmsTrace.reportHottag(logItem);
    }
    else {
        console.log(logItem);
    }
};
/**
 * 检测是否是有效的key
 * @param key
 * @param obj
 * @returns
 */
export const isValidKey = (key, obj) => {
    return obj && key in obj;
};
// 操作用户习惯的工具函数
export const genHabitHandler = habit;
// 操作用户反馈的工具函数
export const feedbackHandler = feedback;
